import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

export const StyledCountryDropdownButton = styled.div`
    color: ${colorsPalettes.carbon[400]};
`;
